<template>
    <div class="">
        <div class="row col-md-12 justify-content-center">
            <h5>{{ labels.title }}</h5> 
        </div>
        <div class="col-md-12 d-flex justify-content-end">
            <b-button style="background-color: #2e507a; width: 35px; height: 35px;" class="md-fab md-primary" @click="adicionaActivo()">
                <i class="fa-solid fa-plus"></i>
            </b-button>
        </div>
        <b-row>
            <b-col cols="12">
                <b-row class="justify-content-center" v-if="listActivos != 0">
                    <b-table
                        :items="listActivos"
                        :fields="fields"
                        hover
                        bordered
                        responsive
                        
                        small
                        class="tblEstandar"
                        head-variant="custom-blue"
                        
                        
                        @row-clicked="(item) => quitarActivo(item.activo)" 
                    >
                        <template #cell(activo)="data">
                            <div class="text-left">{{ tipoActivo(data.item?.activo) }}</div> 
                        </template>
                        <template #cell(descripcion)="data">
                            <div class="text-left">{{ nameActivo(data.item?.activo) }}</div> 
                        </template>
                        <template #cell(valor_inicial)="data">
                            <div class="text-right">{{ valCompra(data.item?.activo) }}</div> 
                        </template>
                        <template #cell(valor_final)="data">
                            <div class="text-right">{{ valFinal(data.item?.activo) }}</div> 
                        </template>
                    </b-table>
                    <div class="row col-md-12 justify-content-center mt-1" v-if="listActivos != 0">
                        <div class="row col-12 mt-1">
                            <div class="col-10 d-flex justify-content-center">
                                <b-pagination
                                :items="currentPage"
                                :total-rows="listActivos.length" 
                                
                                align="center"
                                size="md"
                                class="custom-pagination"
                                ></b-pagination>
                            </div>
                            <div class="col-2 d-flex justify-content-end">
                                <label class="mr-2 mb-0">Filas por página:</label>
                                <b-form-select
                                :items="perPage"
                                :options="[5, 10, 20, 50, 100, 500]"
                                size="sm"
                                style="width: 80px;"
                                ></b-form-select>
                            </div>
                        </div>
                    </div>
                </b-row>
                <b-row class="justify-content-center" v-else>
                    <h5>{{ labels.noRow }}</h5> 
                </b-row>
            </b-col>
        </b-row>
        <b-row v-if="fgl_adicionar">
            <AdicionarActivos :modalAdActivos="showAdActivos" :numContrato="numContrato" @cierraModal="closeModal"></AdicionarActivos>
        </b-row>
        <b-row>
            <!-- <b-col class="d-flex justify-content-end" cols="10">
                <b-button class="md-primary" @click="saveModActivos">{{ labels.save }}</b-button> 
            </b-col> -->
            <b-col class="d-flex justify-content-end" cols="12">
                <b-button class="md-accent" @click="cierraModal">{{ labels.close }}</b-button> 
            </b-col>
        </b-row>
        <!-- <InacticaItem :InactivaItem="quitaActivo" @confirmDelete="confirmInactivate" @cierraModal="cierraModalAdv"></InacticaItem> -->
        <ModModifiElimAct :modModElimAct="showModRetMejAct" :numActivo="codActivo" :nroContrato="numContrato" @cierraModal="closeModAddRet" @refreshTblModAct="refrescaTblModAct"></ModModifiElimAct>
    </div>
</template>

<script>
import ContratoActivo from '../../services/ContratoActivo'; 
import Activos from '../../services/Activos' 
import TipoActivo from '../../services/TipoActivo'; 
import AdicionarActivos from './AdicionarActivos.vue'; 
import ModModifiElimAct from './ModModifiElimAct.vue' 
// import InacticaItem from '../utils/InacticaItem.vue'; 

export default {
    name : 'ModificacionActivos',
    props : ['numContrato'],
    components : {
        AdicionarActivos,
        ModModifiElimAct,
        // InacticaItem,
    },
    data : () => ({
        listActivos : [],
        activos : [],
        lstTipoActivo : [],
        valAddMejora : '',
        valRetiro : '',
        fgl_adicionar: false,
        showAdActivos: false,
        quitaActivo: false,
        codActivo: null,
        showModRetMejAct : false,
        perPage: 500,
        currentPage: 1,
        fields: [
            {key: 'activo', label: 'Tipo activo', sortable: false},
            {key: 'descripcion', label: 'Descripción', sortable: false},
            {key: 'valor_inicial', label: 'Valor inicial', sortable: false},
            {key: 'valor_final', label: 'Valor final', sortable: false},
        ]
    }),
    computed:{
        labels(){
            if(this.$store.state._language == "es-ES"){ 
                return {
                    title : 'Modificación activos',
                    save : 'Guardar',
                    close : 'Cerrar',
                    noRow : "No hay registros",
                    activos : 'Activos',
                    tipoActivo : 'Tipo Activo',
                    proveedor : 'Proveedor',
                    valorCompra : 'Valor Inicial',
                    valorFinal : 'Valor final',
                    valorSalvamento : 'Valor salvamento',
                    valorAmortizado : 'Valor amortizado',
                    fechaCompra : 'Fecha compra',
                    valAddMejora : 'Valor adición/mejora',
                    valRetiro : 'Valor retiro',
                }            
            }else{
                return {
                    title : 'Asset modification',
                    save : 'Save',
                    close : 'Close',
                    noRow : "There are not records",
                    activos : 'Assets',
                    tipoActivo : 'Active type',
                    proveedor : 'Provider',
                    valorCompra : 'Purchase value',
                    valorFinal : 'Valor final',
                    valorSalvamento : 'Salvage value',
                    valorAmortizado : 'Amortized value',
                    fechaCompra : 'Purchase date',
                    valAddMejora : 'Added value/Improvement',
                    valRetiro : 'Withdrawal value'
                }                
            }
        }
    },
    methods:{
        cierraModal(){
            this.$emit('cierraModal',false) 
        },
        saveModActivos(){
            console.log('saveModActivos'); 
        },
        quitarActivo(activo){
            // console.log('quitarActivo',activo); 
            this.codActivo = activo 
            this.quitaActivo = true 
            this.showModRetMejAct = true 
        },
        confirmInactivate(){
            const info = {
                'activo' : this.codActivo, 
                'numContrato' : this.numContrato, 
                'idUser' : this.$store.state.userId 
            }

            Activos.quitarActivoAlContrato(info) 
            .then((res) => { 
                // console.log(res.data); 
                if (res.status == 200) { 
                    this.$toast.success(res.data.message); 
                    this.$router.push('modificarcontrato'); 
                    location.reload(); 
                }
            })
            .catch((error) => { 
                if (error.response && error.response.data) { 
                    this.$toast.error(error.response.data.message); 
                }
            })
        },
        cierraModalAdv(){
            this.quitaActivo = false 
        },
        closeModAddRet(){
            this.showModRetMejAct = false 
        },
        nameActivo(numActivo){
            let name = this.activos.find((activo) => activo.activo == numActivo) 
            if	(name == undefined) {
                return numActivo
            }
            return name?.descripcion 
        },
        tipoActivo(numActivo){
            if	(numActivo == null || numActivo == undefined) {
                return numActivo
            }
            let numTipoActivo = this.activos.find((activo) => activo.activo == numActivo) 
            if	(numTipoActivo == undefined) {
                return numActivo
            }
            let nameTipoActivo = this.lstTipoActivo.find((tipoAct) => tipoAct.tipo_activo == numTipoActivo.tipo_activo) 
            if	(nameTipoActivo == undefined) {
                return "Tipo Activo "+numActivo
            }
            return nameTipoActivo?.descripcion 
        },
        valCompra(numActivo){
            let valor = this.activos.find((activo) => activo.activo == numActivo) 
            if	(valor == undefined) {
                return numActivo
            }
            return Intl.NumberFormat('es-CO',{ maximumFractionDigits: 3, minimumFractionDigits: 0}).format(valor?.valor_compra) 
        },
        valFinal(numActivo){
            let valor = this.activos.find((activo) => activo.activo == numActivo) 
            if	(valor == undefined) {
                return numActivo
            }
            return Intl.NumberFormat('es-CO',{ maximumFractionDigits: 3, minimumFractionDigits: 0}).format(valor?.valor_final) 
        },
        adicionaActivo() {
            this.fgl_adicionar = true 
            this.showAdActivos = true 
        },
        closeModal(val){
            this.showAdActivos = val 
        },
        refrescaTblModAct(){
            Activos.getAllActivos() 
            .then((res) => { 
                this.activos = res.data.listActivos 
            })
            .catch((err) => console.log(err)) 
        }
    },
    mounted(){
        Activos.getAllActivos() 
        .then((res) => { 
            this.activos = res.data.listActivos 
        })
        .catch((err) => console.log(err)) 

        ContratoActivo.getActivoContratoByNumContr(this.numContrato) 
        .then((res) => { 
            this.listActivos = res.data.activosContrato 
        })
        .catch((err) => console.log(err)) 


        TipoActivo.getAllTipoActivo() 
        .then((res) => { 
            // console.log(res.data.listTipoActivo); 
            this.lstTipoActivo = res.data.listTipoActivo 
        })
        .catch((err) => console.log(err)) 
    }
}
</script>
